import { apmCaptureError } from '../../apm'
import { CustomError } from '../../base-errors'

export const handleAddToCartErrorApm = (error: unknown): void => {
  apmCaptureError(
    new CustomError(
      {
        message: 'failed to add product to the cart',
        name: 'CART_INTERMEDIATE_ADD_TO_CART_BUY_TOGETHER_FAIL',
      },
      {
        cause: error,
      },
    ),
  )
}
